import React from "react";
import image from "../assets/IMG_9156.jpg";
function About(props) {
  return (
    <div id="about" className="about" data-aos={"fade-up"}>
      <span>About Me ! 🤵</span>
      <div className="row">
        <div className="col-sm-12 col-md-7 my-5 about__text">
          <p>
            Hey👋, I'm Naivedh Shah from India. I have completed my bachelor's
            in computer engineering. I am a tech enthusiast, web developer and a
            data analyst. I enjoy working with trending libraries like ReactJs
            and TensorFlow. 👨‍💻
          </p>
        </div>
        <div className="col-sm-12 col-md-5 my-5 about__image">
          <img src={image} alt="Naivedh" />
        </div>
      </div>
    </div>
  );
}

export default About;
